class UploadHelper {
    constructor(element) {
        this.element = element
        this.id = this.element.id
        this.selectedFilesObj = document.createElement('div')
        this.selectedFilesObj.ariaAtomic = 'true'
        this.selectedFilesObj.classList = 'field__upload-helper-box'
        this.init()
    }

    init() {
        this.element.addEventListener('change', () => this.listSelectedFiles())
        this.element.insertAdjacentElement('afterend', this.selectedFilesObj)
    }

    listSelectedFiles() {
        const newUl = this.arrayToUnorderedList(this.element.files, 'name')
      
        this.selectedFilesObj.replaceChildren(newUl)
        this.element.files.length ? this.selectedFilesObj.insertAdjacentElement('afterbegin', this.resetUploadButton()) : null
    }

    arrayToUnorderedList(array, value) {
        const files = Object.keys(array)
        const ul = document.createElement('ul')
        ul.classList = 'field__upload-helper'
     
        files.map(key => {
            const li = document.createElement('li')
            li.textContent = array[key][value] ?? ''
            ul.appendChild(li)
        })
        return ul
    }

    resetUploadButton(){
        const button = document.createElement('button')
        button.innerHTML = `<svg class="icon icon-bin" width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor" focusable="false" aria-hidden="true">
  <path d="M30 3.20483H0V5.16498H4.60619V30H25.3938V5.16498H30V3.20483ZM23.555 28.0399H6.44499V5.16498H23.555V28.0399Z M19.3077 0H10.4355V1.96014H19.3077V0Z M12.4306 10.3496H10.5918V22.8651H12.4306V10.3496Z M19.2978 10.3496H17.459V22.8651H19.2978V10.3496Z"></path>
</svg>`
        button.classList = 'drop-zone-reset'
        button.addEventListener('click', e => {
            this.element.value = ''
            this.listSelectedFiles()
        })
        return button
    }

}

export default UploadHelper